/* Checkpoint Mol — productkaart: fotocarrousel + matenpaneel (19-10-2026, versie 5)
   Foto's — mobiel/touch: horizontaal vegen bladert (eigen touch-afhandeling, geen native scroll), bolletjes tonen de positie;
                           één tik op de foto = productpagina.
            desktop (muis): hover toont foto 2 na een korte pauze (150 ms, zodat het raster stil blijft als je er enkel over scrolt),
                            pijltjes bladeren, muis weg = terug naar foto 1.
            data-cp-no-swipe op het element (rijen Meer van / Combineert dit zo / Net bekeken): geen vegen in de kaart, de rij zelf scrolt.
   Maten  — knopje "Maten" rechtsonder opent een paneel met de voorradige maten; kruisje, tik ernaast of Escape sluit het. */
(function () {
  if (window.customElements.get('checkpoint-card-media')) return;

  var SWIPE_MIN = 24;      // px horizontaal om te bladeren
  var LOCK_RATIO = 1.2;    // horizontaal moet duidelijk groter zijn dan verticaal
  var HOVER_DELAY = 150;   // ms pauze voor de tweede foto verschijnt (desktop)

  class CheckpointCardMedia extends HTMLElement {
    connectedCallback() {
      if (this.cpReady) return;
      this.cpReady = true;
      var self = this;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.noSwipe = this.hasAttribute('data-cp-no-swipe');
      this.hoverTimer = null;
      var wrapper = this.closest('.product-card__wrapper') || this;

      /* --- Matenpaneel --- */
      this.sizesToggle = this.querySelector('[data-cp-sizes-toggle]');
      this.sizesPanel = this.querySelector('[data-cp-sizes]');
      this.sizesClose = this.querySelector('[data-cp-sizes-close]');
      this.outsideHandler = null;
      if (this.sizesToggle && this.sizesPanel) {
        this.sizesToggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.toggleSizes();
        });
        if (this.sizesClose) {
          this.sizesClose.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.toggleSizes(false);
          });
        }
        this.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') self.toggleSizes(false);
        });
      }

      /* --- Carrousel --- */
      this.track = this.querySelector('[data-cp-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-cp-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.cp-card-media__dot'));
      this.count = this.slides.length;
      this.index = 0;

      if (this.track && this.count > 1) {
        var prev = this.querySelector('[data-cp-prev]');
        var next = this.querySelector('[data-cp-next]');
        if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.go(self.index - 1); });
        if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.go(self.index + 1); });

        /* Touch: vegen (niet in rijen die zelf horizontaal scrollen) */
        if (!this.noSwipe) {
          this.startX = 0; this.startY = 0; this.deltaX = 0; this.swiping = false; this.locked = null; this.suppressClick = false;
          this.track.addEventListener('touchstart', function (e) {
            if (e.touches.length !== 1) return;
            self.startX = e.touches[0].clientX;
            self.startY = e.touches[0].clientY;
            self.deltaX = 0;
            self.locked = null;
            self.swiping = true;
            self.track.classList.add('is-dragging');
            self.preload(self.index + 1);
            self.preload(self.index - 1);
          }, { passive: true });
          this.track.addEventListener('touchmove', function (e) {
            if (!self.swiping) return;
            var dx = e.touches[0].clientX - self.startX;
            var dy = e.touches[0].clientY - self.startY;
            if (self.locked === null) {
              if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
              self.locked = Math.abs(dx) > Math.abs(dy) * LOCK_RATIO ? 'x' : 'y';
            }
            if (self.locked !== 'x') return;
            if (e.cancelable) e.preventDefault();
            /* weerstand aan de uiteinden */
            if ((self.index === 0 && dx > 0) || (self.index === self.count - 1 && dx < 0)) dx = dx / 3;
            self.deltaX = dx;
            self.setTransform(-self.index * 100, dx);
          }, { passive: false });
          var endSwipe = function () {
            if (!self.swiping) return;
            self.swiping = false;
            self.track.classList.remove('is-dragging');
            if (self.locked === 'x' && Math.abs(self.deltaX) > SWIPE_MIN) {
              self.suppressClick = true;
              window.setTimeout(function () { self.suppressClick = false; }, 400);
              self.go(self.deltaX < 0 ? self.index + 1 : self.index - 1, true);
            } else {
              self.go(self.index, true);
            }
            self.deltaX = 0;
            self.locked = null;
          };
          this.track.addEventListener('touchend', endSwipe, { passive: true });
          this.track.addEventListener('touchcancel', endSwipe, { passive: true });
          this.track.addEventListener('click', function (e) {
            if (self.suppressClick) { e.preventDefault(); e.stopPropagation(); }
          }, true);
        }

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            self.preload(1);
            self.io.disconnect();
          }, { rootMargin: '0px' });
          this.io.observe(this);
        }
      }

      /* --- Desktop hover: korte pauze, dan foto 2; muis weg = terug --- */
      wrapper.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !self.finePointer.matches) return;
        if (self.count > 1) {
          self.preload(1);
          if (self.hoverTimer) window.clearTimeout(self.hoverTimer);
          self.hoverTimer = window.setTimeout(function () {
            self.hoverTimer = null;
            if (self.index === 0) self.go(1);
          }, HOVER_DELAY);
        }
      });
      wrapper.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse' || !self.finePointer.matches) return;
        if (self.hoverTimer) { window.clearTimeout(self.hoverTimer); self.hoverTimer = null; }
        if (self.count > 1) self.go(0);
        self.toggleSizes(false);
      });
    }

    setTransform(percent, px) {
      this.track.style.transform = 'translate3d(calc(' + percent + '% + ' + (px || 0) + 'px), 0, 0)';
    }

    toggleSizes(force) {
      if (!this.sizesToggle || !this.sizesPanel) return;
      var open = typeof force === 'boolean' ? force : !this.classList.contains('is-open');
      if (open === this.classList.contains('is-open')) return;
      var self = this;
      this.classList.toggle('is-open', open);
      this.sizesToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (this.outsideHandler) {
        document.removeEventListener('click', this.outsideHandler, true);
        this.outsideHandler = null;
      }
      if (open) {
        this.outsideHandler = function (ev) {
          if (self.contains(ev.target)) return;
          self.toggleSizes(false);
        };
        window.setTimeout(function () {
          if (self.outsideHandler) document.addEventListener('click', self.outsideHandler, true);
        }, 0);
      }
    }

    preload(i) {
      var slide = this.slides[i];
      if (!slide) return;
      var img = slide.querySelector('img');
      if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    }

    go(i, clamp) {
      if (!this.track || this.count < 2) return;
      var n = this.count;
      if (clamp) {
        if (i < 0) i = 0;
        if (i > n - 1) i = n - 1;
      } else {
        i = ((i % n) + n) % n;
      }
      this.index = i;
      this.preload(i);
      this.preload(i + 1);
      this.setTransform(-i * 100, 0);
      this.setDots(i);
    }

    setDots(i) {
      for (var k = 0; k < this.dots.length; k++) {
        this.dots[k].classList.toggle('is-active', k === i);
      }
    }
  }

  window.customElements.define('checkpoint-card-media', CheckpointCardMedia);
})();
